import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
const setTimeZoneNotProvided = (timezone) => {
    console.log('Cannot set timezone. Missing action.');
};
const setMethodNotProvided = (method) => {
    console.log('Cannot set method. Missing action.');
};
const defaultContext = {
    timeZonesForSelect: [],
    timeZonesMapping: {},
    timezone: 'America/New_York',
    method: 'dynamic',
    setTimeZone: setTimeZoneNotProvided,
    setMethod: setMethodNotProvided
};
export const TimeZoneContext = createContext(defaultContext);
export function TimeZoneContextProvider(params) {
    var _a;
    const [targetTimezone, setTargetTimezone] = useState((_a = params.initialTimezone) !== null && _a !== void 0 ? _a : 'America/New_York');
    const [targetMethod, setTargetMethod] = useState('fixed');
    const setTimeZone = useCallback((timezone) => {
        setTargetTimezone(timezone !== null && timezone !== void 0 ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, []);
    const setMethod = useCallback((method) => {
        setTargetMethod(method);
    }, []);
    useEffect(() => {
        if (targetMethod === 'dynamic')
            setTargetTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, [targetMethod]);
    const contextData = useMemo(() => {
        var _a, _b;
        const value = {
            timeZonesForSelect: (_a = params.timeZonesForSelect) !== null && _a !== void 0 ? _a : [],
            timeZonesMapping: (_b = params.timeZonesMapping) !== null && _b !== void 0 ? _b : {},
            timezone: targetTimezone,
            method: targetMethod,
            setTimeZone,
            setMethod
        };
        return value;
    }, [params.timeZonesForSelect, params.timeZonesMapping, setMethod, setTimeZone, targetMethod, targetTimezone]);
    return React.createElement(TimeZoneContext.Provider, { value: contextData }, params.children);
}
